export { PDFExportComponent } from './pdf-export.component';
export { PDFExportModule } from './pdf-export.module';
export { PDFMarginComponent } from './pdf-margin.component';
export { PDFTemplateDirective } from './pdf-template.directive';
export { compileTemplate } from './compile-template';



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-pdf-export/dist/es/main.js
// module id = ../../../../@progress/kendo-angular-pdf-export/dist/es/main.js
// module chunks = vendor